import { I18n as I } from 'react-redux-i18n';
import FormHelper from 'lib/FormHelper';
import { isNil, isNullOrWhitespace, isNumber, isString } from 'vdlib';

const validate = (fields, keyOrData, value, stopOnError) => {
  var excludeFields = ['Mobile', 'Fax'];
  if (typeof keyOrData === 'string') {
    if (isNumber(value)) {
      return FormHelper.isPositiveNumber(value)
        ? null
        : { [keyOrData]: I.t('CHOOSE_VALUE') };
    } else if (isString(value)) {
      return isNullOrWhitespace(value)
        ? { [keyOrData]: I.t('FIELD_CANNOT_BE_EMPTY') }
        : null;
    }
  } else {
    var fieldsToValidate = fields.filter(
      f => excludeFields.indexOf(f.name) < 0
    );
    var obj = {};
    for (var field of fieldsToValidate) {
      if (isNumber(keyOrData[field.name])) {
        if (!FormHelper.isPositiveNumber(keyOrData[field.name]))
          obj[field.name] = I.t('CHOOSE_VALUE');
      } else if (isString(keyOrData[field.name])) {
        if (isNullOrWhitespace(keyOrData[field.name]))
          obj[field.name] = I.t('FIELD_CANNOT_BE_EMPTY');
      }

      if (stopOnError === true && !isNil(obj[field.name])) return obj;
    }

    return obj;
  }
};

export { validate };
